import type { InspectionFormState, InspectionFormAction } from "../useInspectionForm";

interface Props {
  state: InspectionFormState;
  dispatch: React.Dispatch<InspectionFormAction>;
}

const labelCls = "text-xs font-medium text-foreground-500 mb-1 block";
const selectCls = "w-full bg-white border border-background-200/70 rounded-lg px-3 py-2 text-sm text-foreground-800 focus:outline-none focus:border-primary-300 focus:ring-1 focus:ring-primary-200 transition-colors appearance-none cursor-pointer";
const inputCls = "w-full bg-white border border-background-200/70 rounded-lg px-3 py-2 text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 focus:ring-1 focus:ring-primary-200 transition-colors";

const INTERFERENCE_TYPES = [
  { value: "OVERHEAD_NETWORK", label: "Rede aérea" },
  { value: "SIDEWALK", label: "Calçada" },
  { value: "TRAFFIC_VISIBILITY", label: "Visibilidade de tráfego" },
  { value: "LIGHTING", label: "Iluminação" },
  { value: "BUILDING", label: "Edificação" },
  { value: "UNDERGROUND_INFRASTRUCTURE", label: "Infraestrutura subterrânea" },
  { value: "URBAN_FURNITURE", label: "Mobiliário urbano" },
  { value: "OTHER", label: "Outro" },
];

const INTENSITY_LEVELS = [
  { value: "BAIXA", label: "Baixa" },
  { value: "MEDIA", label: "Média" },
  { value: "ALTA", label: "Alta" },
  { value: "CRITICA", label: "Crítica" },
];

export default function StepConflitos({ state, dispatch }: Props) {
  return (
    <div className="space-y-5">
      <div className="bg-white rounded-xl border border-background-200/70 p-4">
        <div className="flex items-center justify-between mb-3">
          <h4 className="text-sm font-semibold text-foreground-800 flex items-center gap-2">
            <i className="ri-flashlight-line text-warning-500"></i>
            Conflitos Urbanos
          </h4>
          <button
            type="button"
            onClick={() =>
              dispatch({
                type: "ADD_INTERFERENCE",
                interference: { interferenceType: "OVERHEAD_NETWORK" },
              })
            }
            className="text-xs text-primary-600 hover:text-primary-700 font-medium flex items-center gap-1"
          >
            <i className="ri-add-line"></i> Adicionar conflito
          </button>
        </div>

        {state.interferences.length === 0 ? (
          <div className="text-center py-8">
            <i className="ri-checkbox-circle-line text-3xl text-primary-300"></i>
            <p className="text-sm text-foreground-500 mt-2">Nenhum conflito urbano registrado.</p>
            <p className="text-xs text-foreground-400">Adicione conflitos com a rede aérea, calçada, edificações etc.</p>
          </div>
        ) : (
          <div className="space-y-3">
            {state.interferences.map((interf, idx) => (
              <div key={idx} className="p-3 bg-background-50 rounded-lg border border-background-200/50">
                <div className="flex items-center justify-between mb-2">
                  <span className="text-xs font-semibold text-foreground-600">Conflito #{idx + 1}</span>
                  <button
                    type="button"
                    onClick={() => dispatch({ type: "REMOVE_INTERFERENCE", index: idx })}
                    className="text-xs text-danger-500 hover:text-danger-600"
                  >
                    <i className="ri-delete-bin-line"></i>
                  </button>
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                  <div>
                    <label className={labelCls}>Tipo de conflito</label>
                    <select
                      value={interf.interferenceType}
                      onChange={(e) =>
                        dispatch({ type: "UPDATE_INTERFERENCE", index: idx, field: "interferenceType", value: e.target.value })
                      }
                      className={selectCls}
                    >
                      {INTERFERENCE_TYPES.map((t) => (
                        <option key={t.value} value={t.value}>{t.label}</option>
                      ))}
                    </select>
                  </div>
                  <div>
                    <label className={labelCls}>Intensidade</label>
                    <select
                      value={interf.intensity ?? ""}
                      onChange={(e) =>
                        dispatch({ type: "UPDATE_INTERFERENCE", index: idx, field: "intensity", value: e.target.value || null })
                      }
                      className={selectCls}
                    >
                      <option value="">—</option>
                      {INTENSITY_LEVELS.map((i) => (
                        <option key={i.value} value={i.value}>{i.label}</option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="mt-2">
                  <label className={labelCls}>Descrição</label>
                  <input
                    type="text"
                    value={interf.description ?? ""}
                    onChange={(e) =>
                      dispatch({ type: "UPDATE_INTERFERENCE", index: idx, field: "description", value: e.target.value || null })
                    }
                    placeholder="Descreva o conflito..."
                    className={inputCls}
                  />
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
